// components/retro/avatar/avatar.component.jsx
import React from "react";
import { BsPersonCheck } from "react-icons/bs";

import Peep from "../../avatar-creator/Peep";

import "./avatar.styles.scss";

const firstPhoto = (value) => {
  if (Array.isArray(value)) return value.find(Boolean) || null;
  return value || null;
};

const Avatar = ({ src, user, size, tiny = false, backgroundColor = "lightgray", overflow = "hidden" }) => {
  const photo = firstPhoto(src || user?.imageUrl);

  if (user?.preferences?.showAvatar && user?.imgAvatar) {
    return (
      <div className="avatar_peep_container">
        <Peep
          useravatar={user.imgAvatar}
          size={60}
          width={size || 40}
          height={size || 40}
          borderRadius={25}
          borderColor="black"
          borderWidth={0}
          overflow={overflow}
          backgroundColor={backgroundColor}
          tiny={tiny}
        />
      </div>
    );
  }

  if (photo) {
    return (
      <div
        className="avatar"
        style={size ? { width: size, height: size } : undefined}
      >
        <img alt="" src={photo} />
      </div>
    );
  }

  return <BsPersonCheck />;
};

export default Avatar;